import { useEffect, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";

// import CustomInput from "components/CustomComponents/FormComponents/Input";
import CustomInput from "../../CustomComponents/FormComponents/Input";
import CustomPhoneInput from "../../CustomComponents/FormComponents/PhoneInput";
import CustomRadio from "../../CustomComponents/FormComponents/Radio";
import CustomCheckbox from "../../CustomComponents/FormComponents/Checkbox";
import CustomSwitch from "../../CustomComponents/FormComponents/Switch";
import CustomDatePicker from "../../CustomComponents/FormComponents/DatePicker";
import CustomDateRangePicker from "../../CustomComponents/FormComponents/DateRangePicker";
import CustomTimePicker from "../../CustomComponents/FormComponents/TimePicker";
import CustomTimeRangePicker from "../../CustomComponents/FormComponents/TimeRangePicker";
import CustomFileUpload from "../../CustomComponents/FormComponents/FileUpload";
// import CustomCKEditor from "../../CustomComponents/CustomCKEditor";

import { FIELD_TYPES } from "../constants";
import JFLabel from "./JFLabel";
import useDisplayCheck from "../useDisplayCheck";
import CustomSelect from "components/CustomComponents/FormComponents/Select";
import FormField from "components/FormField";
import NumberRange from "components/CustomComponents/FormComponents/NumberRange";

interface JFFieldProps {
	field: any;
	isFieldArray?: boolean;
	customComponents?: any;
}

const JFField: React.FC<JFFieldProps> = ({
	field,
	isFieldArray,
	customComponents = {},
}) => {
	const {
		name,
		classes,
		fieldProps,
		fieldType,
		placeholder = "",
	} = field;
	const firstRender = useRef(true);

	const { control, getValues, setValue } = useFormContext();

	const display = useDisplayCheck(field?.visible);

	// const [dependency, setDependency] = useState<{ [key: string]: any }>({});

	// const watchers = useWatch({
	// 	control,
	// 	name: Object.values(fieldProps?.dependency || {}),
	// });

	useEffect(() => {
		if (firstRender.current && fieldType === FIELD_TYPES.select && name) {
			firstRender.current = false;
			const value = getValues(name);
			const newValue = Array.isArray(value)
				? value.map((a) => (typeof a === "object" ? a.value : a))
				: typeof value === "object"
				? value?.value || null
				: value || null;
			setValue(name, newValue, { shouldValidate: false });
		}
	}, [fieldType, getValues, name, setValue]);

	// useEffect(() => {
	// 	// To reset the fields
	// 	if (watchers && watchers.length) {
	// 		resetField(name);
	// 		setDependency(
	// 			Object.entries(fieldProps?.dependency || {}).reduce(
	// 				(prev, [key], index) => {
	// 					prev[key] = watchers[index];
	// 					return prev;
	// 				},
	// 				{} as { [key: string]: any }
	// 			)
	// 		);
	// 	}
	// }, [fieldProps?.dependency, name, resetField, watchers]);

	return name ? (
		<>
			{display ? (
				<div className={`pb-3 ${!isFieldArray ? classes?.wrapper : "w-full"}`}>
					<JFLabel field={field} customComponents={customComponents} />
					<Controller
						name={name}
						control={control}
						render={({
							field: { onChange, name, value },
							fieldState: { error },
						}) => {
							switch (fieldType) {
								case FIELD_TYPES.input:
									return (
										<CustomInput
											type={fieldProps?.type ?? "text"}
											name={name}
											value={value}
											onChange={(e) => onChange(e.target.value)}
											error={error?.message}
											{...fieldProps}
											// placeholder={fieldProps?.placeholder}
											// note={fieldProps?.note}
											// disabled={fieldProps?.disabled}
											// autoComplete={fieldProps?.autoComplete}
										/>
									);
								case FIELD_TYPES.numberRange:
									return (
										<NumberRange
											name={name}
											placeholder={fieldProps?.placeholder}
											value={value}
											onChange={(e) => onChange(e)}
											disabled={fieldProps?.disabled}
											error={error?.message}
										/>
									);
								case FIELD_TYPES.phone:
									return (
										<CustomPhoneInput
											placeholder={fieldProps?.placeholder}
											value={value}
											onChange={(e) => onChange(e)}
											disabled={fieldProps?.disabled}
											error={error?.message}
										/>
									);
								case FIELD_TYPES.radio:
									return (
										<div className="py-2">
											<CustomRadio
												name={name}
												value={value}
												onChange={(e) => onChange(e.target.value)}
												options={fieldProps?.options}
												disabled={fieldProps?.disabled}
												error={error?.message}
												direction={fieldProps?.direction}
											/>
										</div>
									);
								case FIELD_TYPES.checkbox:
									return (
										<div className="py-2">
											<CustomCheckbox
												name={name}
												value={value}
												onChange={(value) => onChange(value)}
												options={fieldProps?.options}
												disabled={fieldProps?.disabled}
												error={error?.message}
											/>
										</div>
									);
								case FIELD_TYPES.textarea:
									return (
										<FormField
											multiline
											label={fieldProps?.label}
											name={name}
											onChange={(value) => onChange(value)}
											isRequired
											error={error?.message}
											{...fieldProps}
										/>
									);
								// case FIELD_TYPES.tags:
								// 	return (
								// 		<CustomTagsInput
								// 			value={value}
								// 			onChange={(e) => onChange(e)}
								// 			disabled={fieldProps?.disabled}
								// 			placeholder={fieldProps?.placeholder}
								// 			className={fieldProps?.className}
								// 			error={error?.message}
								// 		/>
								// 	);
								case FIELD_TYPES.switch:
									return (
										<div className="py-2">
											<CustomSwitch
												value={value}
												onChange={(e) => onChange(e)}
												label={fieldProps?.label}
												disabled={fieldProps?.disabled}
												className={fieldProps?.className}
												error={error?.message}
											/>
										</div>
									);
								case FIELD_TYPES.date:
									return (
										<CustomDatePicker
											value={value}
											onChange={(e) => onChange(e)}
											error={error?.message}
											{...fieldProps}
										/>
									);
								case FIELD_TYPES.dateRange:
									return (
										<CustomDateRangePicker
											value={value}
											onChange={(e) => onChange(e)}
											error={error?.message}
											{...fieldProps}
										/>
									);
								case FIELD_TYPES.time:
									return (
										<CustomTimePicker
											value={value}
											onChange={(e) => onChange(e)}
											error={error?.message}
											{...fieldProps}
										/>
									);
								case FIELD_TYPES.timeRange:
									return (
										<CustomTimeRangePicker
											value={value}
											onChange={(e) => onChange(e)}
											error={error?.message}
											{...fieldProps}
										/>
									);
								case FIELD_TYPES.select:
									return (
										<CustomSelect
											value={value}
											onChange={onChange}
											error={error?.message}
											placeholder={placeholder}
											{...fieldProps}
										/>
									);
								case FIELD_TYPES.fileUpload:
									return (
										<CustomFileUpload
											fileData={value}
											onChange={(e) => onChange(e)}
											error={error?.message}
											{...fieldProps}
										/>
									);
								// case FIELD_TYPES.ckEditor:
								// 	return (
								// 		<CustomCKEditor
								// 			name={name}
								// 			value={value}
								// 			onChange={({ data }) => onChange(data)}
								// 			error={error?.message}
								// 			{...fieldProps}
								// 		/>
								// 	);
								default:
									return (
										<div className="text-danger">No Such Form Field Exist</div>
									);
							}
						}}
					/>
				</div>
			) : (
				<></>
			)}
		</>
	) : (
		<div>Please provide name of the field</div>
	);
};

export default JFField;
